import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { ILogin, ILoginResponse, INewPassword, IRegisterMidwife, IRegisterMidWifeResponse, IRegisterMum, IRegisterMumResponse, IRequestOtp, IUser, IUserData, IUserEmail, IVerifyOtp} from '../models/auth.models';
import { Observable } from 'rxjs';
import { Router } from '@angular/router';
import { userType } from '../constants/global-constants';
import { IGenericResponse } from '../models/shared.models';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  token?: string = undefined;
  user?: IUser = undefined;
  email: string = '';
  userName: string = '';
  midwifeId?: number = undefined;
  mumId?: number = undefined;

  constructor(private http: HttpClient, private router: Router) {
    let tempUser = localStorage.getItem('userInfo');
    let tempToken = localStorage.getItem('token');
    let midwifeId = localStorage.getItem('midwifeId');
    let mumId = localStorage.getItem('mumId');
    let name = localStorage.getItem('userName');
    if (tempToken && tempUser) {
      this.token = tempToken.toString();
      this.user = JSON.parse(tempUser);
    }else {
      this.token = undefined;
      this.user = undefined;
      localStorage.clear();
    }
    if(midwifeId){
      this.midwifeId = Number(midwifeId);
    }
    if(mumId){
      this.mumId = Number(mumId);
    }
    if(name){
      this.userName = name;
    }
  }

  storeToken(token: string){
    this.token = token;
    localStorage.setItem('token', token);
  }

  storeUserInfo(userInfo: IUser){
    this.user = userInfo;
    localStorage.setItem('userInfo', JSON.stringify(userInfo));
  }

  storeMidwifeId(id: number){
    this.midwifeId = id;
    localStorage.setItem('midwifeId', String(id));
  }

  storeMumId(id: number){
    this.mumId = id;
    localStorage.setItem('mumId', String(id));
  }

  setEmail(email: string){
    this.email = email;
  }

  setUserName(name: string){
    this.userName = name;
    localStorage.setItem('userName', name);
  }

  getUserEmail(){
    return this.email;
  }

  getUserID(){
    return this.user?.userId;
  }

  getUserToken(){
    return localStorage.getItem('token');
  }

  getMidwifeId(){
    return this.midwifeId;
  }

  getMumId(){
    return this.mumId;
  }

  getUserName(){
    return this.userName;
  }

  isUserTypeMum(type:string){
    if (type === userType.MUM){
      return true;
    }
    return false;
  }

  login(requestBody:ILogin): Observable<ILoginResponse> {
    requestBody.device = window.navigator.userAgent;
    const url = `${environment.serverUrl}auth/login`
    return this.http.post<ILoginResponse>(url, requestBody);
  }

  logout(){
    this.token = '';
    this.user = {} as IUser;
    this.midwifeId = undefined;
    this.mumId = undefined;
    this.userName = '';
    localStorage.clear();
    this.router.navigate(['/']);
  }

  registerMum(requestBody: IRegisterMum):Observable<IRegisterMumResponse>{
    requestBody.device = window.navigator.userAgent;
    const url = `${environment.serverUrl}auth/registermum`
    return this.http.post<IRegisterMumResponse>(url, requestBody);
  }

  registerMidwife(requestBody: IRegisterMidwife):Observable<IRegisterMidWifeResponse> {
    requestBody.device = window.navigator.userAgent;
    const url = `${environment.serverUrl}auth/registermidwife`
    return this.http.post<IRegisterMidWifeResponse>(url, requestBody);
  }

  verifyOtpBoth(requestBody: IVerifyOtp): Observable<IGenericResponse> {
    const url = `${environment.serverUrl}auth/verifyotpboth`
    return this.http.post<IGenericResponse>(url, requestBody);
  }

  verifyOtpPhone(requestBody: IVerifyOtp): Observable<IGenericResponse> {
    const url = `${environment.serverUrl}auth/verifyotpphone`
    return this.http.post<IGenericResponse>(url, requestBody);
  }

  verifyOtpEmail(requestBody: IVerifyOtp): Observable<IGenericResponse>{
    const url = `${environment.serverUrl}auth/verifyotpemail`
    return this.http.post<IGenericResponse>(url, requestBody);
  }

  requestOtpEmail(requestBody: IRequestOtp): Observable<IGenericResponse> {
    const url = `${environment.serverUrl}auth/otpemail`
    return this.http.post<IGenericResponse>(url, requestBody);
  }

  requestOtpPhone(requestBody: IRequestOtp): Observable<IGenericResponse> {
    const url = `${environment.serverUrl}auth/otpphone`
    return this.http.post<IGenericResponse>(url, requestBody);
  }

  fetchUserData(requestBody: IUserEmail): Observable<IUserData> {
    const url = `${environment.serverUrl}auth/getuserbyemail`
    return this.http.post<IUserData>(url, requestBody);
  }

  resetPassword(body: INewPassword): Observable<IUserData>{
    const url = `${environment.serverUrl}auth/resetpasswordwhileloggedout`
    return this.http.post<IUserData>(url, body);
  }
}
